mixin settingValue(settingClass, panelName, currentPanel, display, openable, withError)
    span(class="#{openable ? 'open-panel' : ''} #{settingClass} #{currentPanel === panelName ? 'active' : ''} #{withError ? 'with-error' : ''}" data-panel-name=panelName)&attributes(attributes)= display

mixin flowSettingValue(panelName, currentPanel, display, openable, withError)
    +settingValue('flow-setting', panelName, currentPanel, display, openable, withError)&attributes(attributes)

mixin hotspotsSettingValue(panelName, currentPanel, display, openable, withError)
    +settingValue('hotspots-setting', panelName, currentPanel, display, openable, withError)&attributes(attributes)
